export const locale = {
  hint: 'Enter your first and last name: ',
  label: 'Patient Name',
  placeholder: 'Patient Name',
  validationMessage: 'The information entered does not match',
};
